<template>
  <div
    class="solfigrtp solfigr_step2 flex-1"
    style="gap: var(--solfigr-gap)"
    :class="[{ gw_loading: loading }]"
  >
    <ExpandCard
      :opened="false"
      :hasScrollIntoView="false"
      persistKey="solfigr_betsizes"
      data-tst="solfigr_betsizes"
      :openerProps="{
        icon: 'mdi-chevron-down',
        rotatedClass: 'rotated_180_before',
        tooltipStyle: 'transform: translate(0, -100%); position: fixed',
      }"
      style="
        --clr-back-title: var(--clr-black-2);
        --clr-back-title-hover: var(--clr-black-2-3);
        --clr-back-title-active: var(--clr-black-2);
        --title-color: var(--clr-white-0);
        --content-padding: var(--solfigr-padding);
        --max-height: 88rem;
        --radius: 4px;
      "
    >
      <template #title>
        <div class="f-row w-100 justify-space-between">
          <div class="my-auto mr-2">
            {{ $t(`solfigr.street_bet_sizes`) }}
          </div>
          <LinkGuide
            v-if="!$i18n.g1"
            class="weight_500 my-auto pa-1 ml-auto"
            :link="links_url_links.bet_sizes.url"
            :text="links_url_links.bet_sizes.text"
            @click.stop
          />
        </div>
      </template>
      <template #default="{ open }">
        <div class="solfigrtp_top">
          <GwBtns
            :options="streetOptions"
            :value="streetTab"
            idKey="id"
            class="gwbtns_horizontal_grey solfigrtp_top_btns w-100"
            style="
              margin-right: 0.5rem;
              border-radius: 4px;
              background: var(--clr-black-1-3);
              --gwbtn-clr-back: var(--clr-black-1-3);
              --gwbtn-clr-active-white: var(--clr-black-3);
              --gwbtn-size: 1rem;
              --gwbtn-height: 1.875rem;
              --gwbtns-padding: 2px;
            "
            tstPrefix="bet_street"
            @click="(_e, item) => (streetTab = item.id)"
          >
            <template #default="{ item }">
              <div class="f-center gw_hvr">
                {{ item.name }}
              </div>
            </template>
          </GwBtns>

          <div
            v-if="streetTab !== 'preflop'"
            class="d-flex"
          >
            <Checkbox
              v-if="!showFlopOverrideWarn"
              class="solfigrtp_top_checkbox my-auto"
              :value="useFlopSizesOnAllStreets"
              :asSwitch="true"
              style="
                --icon-size: 1.25rem;
                --clr-disabled: var(--clr-grey-2);
                --clr-enabled: var(--clr-primary);
              "
              data-tst="solfigr_use_flop"
              @click="toggleUseFlopSizesOnTurnAndRiver()"
            >
              <span
                class="text-medium"
                v-html="$t('solfigr.sizes.use_flop_on_all_streets')"
              />
            </Checkbox>
            <div
              v-else
              class="d-flex f-center my-auto"
              style="gap: 0.25rem"
            >
              <div
                class="gw_btn gw_btn_small text-medium weight_500"
                style="--height: 1.75rem; --padding: 0 0.5rem; justify-content: flex-start"
                @click.stop="
                  ;(showFlopOverrideWarn = false), toggleUseFlopSizesOnTurnAndRiver({ force: true })
                "
              >
                <div class="mdi mdi-check clr-primary"></div>
              </div>
              <div
                class="gw_btn gw_btn_small text-medium weight_500"
                style="--height: 1.75rem; --padding: 0 0.5rem; justify-content: flex-start"
                @click.stop="showFlopOverrideWarn = false"
              >
                <div class="mdi mdi-close clr-error"></div>
              </div>
              <div class="text-medium ml-1 clr-primary">
                {{ $t('solfigr.sizes.override_last_settings_tra01') }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="d-flex f-wrap w-100"
          style="gap: 0.75rem; margin-top: 0.75rem; overflow: hidden"
        >
          <div
            v-for="player in streetTabsPlayers"
            :key="`${streetTab}_${player}`"
            :data-tst="player"
            class="solfigrtp_playerbox gw_loading_text"
            :class="{
              solfigrtp_playerbox_disabled:
                (!tabPreflop && getPlayerCloningState(player)) ||
                (streetTab !== 'flop' && useFlopSizesOnAllStreets),
            }"
          >
            <div class="solfigrtp_playerbox_title">
              <div
                class="mdi solfigrtp_playerbox_icon mr-1 text-normal-large"
                :class="player === 'player_oop' ? 'mdi-account' : 'mdi-account-outline'"
              ></div>

              <div class="solfigrtp_playerbox_position">
                {{ getDisplayPosition(player) }}
              </div>
              <div
                v-if="!tabPreflop && (player === 'player_ip' || player === 'player_oop1')"
                class="d-flex"
              >
                <Checkbox
                  v-if="!showCloningFirstOverrideWarn[player]"
                  :value="getPlayerCloningState(player)"
                  :asSwitch="true"
                  style="
                    margin: auto 0 auto 1rem;
                    --icon-size: 1.25rem;
                    --clr-disabled: var(--clr-grey-2);
                    --clr-enabled: var(--clr-primary);
                  "
                  @click="toggleMimicFirstPlayer({ player })"
                >
                  <span class="text-medium">
                    {{
                      $t('solfigr.sizes.use_oop_settings', {
                        display_position: getPlayerHtmlPosition(players[0].display_position),
                      })
                    }}
                  </span>
                </Checkbox>
                <div
                  v-else
                  class="d-flex f-center my-auto"
                  style="gap: 0.25rem; margin: auto auto auto 1rem"
                >
                  <div
                    class="gw_btn gw_btn_small text-medium weight_500"
                    style="
                      --height: 1.75rem;
                      --padding: 0 0.5rem;
                      --clr-back: var(--clr-black-3);
                      justify-content: flex-start;
                    "
                    @click.stop="
                      ;(showCloningFirstOverrideWarn[player] = false),
                        toggleMimicFirstPlayer({ force: true, player })
                    "
                  >
                    <div class="mdi mdi-check clr-primary"></div>
                  </div>
                  <div
                    class="gw_btn gw_btn_small text-medium weight_500"
                    style="
                      --height: 1.75rem;
                      --padding: 0 0.5rem;
                      --clr-back: var(--clr-black-3);
                      justify-content: flex-start;
                    "
                    @click.stop="showCloningFirstOverrideWarn[player] = false"
                  >
                    <div class="mdi mdi-close clr-error"></div>
                  </div>
                  <div class="text-medium ml-1 clr-primary">
                    {{ $t('solfigr.sizes.override_last_settings_tra01') }}
                  </div>
                </div>
              </div>
            </div>
            <!-- :key here is for i18n dev bug -  _ctx.$t is not a function -->
            <!-- :key="`${streetTab}-${player}`" -->
            <SolfigrSizes
              class="solfigrtp_playerbox_sizes"
              :style="
                getPlayerCloningState(player) ||
                (!['preflop', 'flop'].includes(streetTab) && useFlopSizesOnAllStreets)
                  ? `--clr-ipoop-active:var(--clr-grey-2);
                 --clr-ipoop-error:var(--clr-grey-2);
                 --clr-ipoop-primary:var(--clr-grey-2);
                 --clr-ipoop-primary2:var(--clr-black-3);
                 `
                  : ''
              "
              :inputTabIndex="
                getPlayerCloningState(player) ||
                (!['preflop', 'flop'].includes(streetTab) && useFlopSizesOnAllStreets)
                  ? -1
                  : open
                    ? 1
                    : -1
              "
              :allow_limp
              :street="streetTab"
              :sizes
              :player
              :playersCount="players.length"
              :overlayCopyFlop="
                useFlopSizesOnAllStreets && !['preflop', 'flop'].includes(streetTab)
              "
              :firstPlayer="players[0]"
              :cloneThisPlayerToRest="player === 'player_oop'"
              :playersCloningFirstPlayer
              :overlayCopyFirstPlayer="
                !tabPreflop && player !== 'player_oop' && playersCloningFirstPlayer[player]
              "
              :forceOnlyFixed="players.length === 3"
              style="
                border: solid 2px var(--clr-black-2);
                border-top: none;
                border-radius: 0 0 4px 4px;
              "
              @update:sizes="
                sizes => {
                  if (getPlayerCloningState(player)) return
                  handleUpdateSizes({ sizes })
                }
              "
              @click:disableclonefirstplayer="
                player => toggleMimicFirstPlayer({ force: true, player })
              "
              @click:disablecopyflop="toggleUseFlopSizesOnTurnAndRiver({ force: true })"
            />
          </div>

          <ExpandCard
            :opened="false"
            :hasScrollIntoView="false"
            :title="$t('solfigr.sizes.use_fixed_sizes_allin_options')"
            persistKey="solfigr_allinoptions"
            data-tst="solfigr_allinoptions"
            style="
              --clr-back-title: var(--clr-black-2);
              --clr-back-title-hover: var(--clr-black-2-3);
              --clr-back-title-active: var(--clr-black-2);
              --title-color: var(--clr-white-0);
              --content-padding: 0;
              --max-height: 16rem;
              --radius: 4px;
            "
          >
            <template #default="{ open: cardOpen }">
              <SolfigrSizesAllinSettings
                :loading="loading"
                style="
                  padding: var(--solfigr-padding);
                  border: solid 2px var(--clr-black-2);
                  border-top: none;
                  border-radius: 0 0 4px 4px;
                "
                :inputTabIndex="cardOpen ? 1 : -1"
                :allinTreshold="allinTreshold"
                :allinIfLessThan="allinIfLessThan"
                :mergeSizesThresholdPreflop="mergeSizesThresholdPreflop"
                :mergeSizesThresholdFlop="mergeSizesThresholdFlop"
                :maxNumRaises="maxNumRaises"
                :isPreflop="isPreflop"
                @update:allinsettings="
                  ({ key, value }) => $emit('update:allinsettings', { key, value })
                "
              />
            </template>
          </ExpandCard>
        </div>
      </template>
    </ExpandCard>
  </div>
</template>

<script>
import {
  getSizesDiffsOnAllStreets,
  getFlopOnTurnAndRiverDiffs,
} from '@/store/solfigr/solfigr_helpers'
import SolfigrSizes from '@/components/ConfigureSolution/SolfigrSizes'
import SolfigrSizesAllinSettings from '@/components/ConfigureSolution/SolfigrSizesAllinSettings'
import GwBtns from '@/components/lib/GwBtns'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import LinkGuide from '@/components/AppBar/LinkGuide'

import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'SolfigrBetSizes',
  components: {
    SolfigrSizes,
    SolfigrSizesAllinSettings,
    GwBtns,
    Checkbox,
    ExpandCard,
    LinkGuide,
  },
  mixins: [float_mix, format_mix, links_mix],
  props: {
    namespace: { String, required: true },
    isPreflop: Boolean,
    sizes: Object,
    useFlopSizesOnAllStreets: Boolean,
    allinTreshold: Number,
    allinIfLessThan: Number,
    mergeSizesThresholdPreflop: Number,
    mergeSizesThresholdFlop: Number,
    maxNumRaises: Number,
    formResult: Object,
    loading: Boolean,

    players: Array,
    betSizesCloning: Object,
    playersCloningFirstPlayer: Object,
  },
  emits: [
    'update:allinsettings',
    'update:preview',
    'update:sizes',
    'update:useFlopSizesOnAllStreets',
    'update:cloneToFirstPlayer',
  ],
  data() {
    return {
      streetTab: 'flop',
      playerTab: 'player_ip',
      showFlopOverrideWarn: false,
      showCloningFirstOverrideWarn: { player_ip: false, player_oop1: false },
    }
  },
  methods: {
    handleIsPreflopChanged() {
      this.streetTab = this.isPreflop ? 'preflop' : 'flop'
    },
    handleActionClick({ item, action }) {
      this.$emit('update:preview', { item, action })
    },
    emitUpdate(sizes, street = this.streetTab) {
      this.$emit('update:sizes', {
        sizes,
        street,
      })
    },
    handleUpdateSizes({ sizes }) {
      let sizes_final = sizes

      if (this.useFlopSizesOnAllStreets) {
        const res = this.getFlopOnTurnAndRiverDiffs(sizes)
        sizes_final = res.sizes_final
      }

      this.emitUpdate(sizes_final)
    },
    toggleUseFlopSizesOnTurnAndRiver({ force = false } = {}) {
      this.showFlopOverrideWarn = false

      const l_sizes = JSON.parse(JSON.stringify(this.sizes))

      const {
        sizes_final,
        diffs_total,
        diffs_ip_flop_turn,
        diffs_oop_flop_turn,
        diffs_ip_flop_river,
        diffs_oop_flop_river,
        diffs_oop1_flop_turn,
        diffs_oop1_flop_river,
      } = this.getFlopOnTurnAndRiverDiffs(l_sizes)

      if (!this.useFlopSizesOnAllStreets && !force) {
        if (diffs_total) {
          this.showFlopOverrideWarn = true
          return
        }
      }

      // no diffs, just toggle
      if (!diffs_total) {
        this.$emit('update:useFlopSizesOnAllStreets', !this.useFlopSizesOnAllStreets)
        return
      }

      const diffsTurn =
        diffs_ip_flop_turn.total + diffs_oop_flop_turn.total + (diffs_oop1_flop_turn?.total ?? 0)
      const diffsRiver =
        diffs_ip_flop_river.total + diffs_oop_flop_river.total + (diffs_oop1_flop_river?.total ?? 0)
      let street = diffsTurn ? 'turn' : diffsRiver ? 'river' : 'error'

      if (street === 'error') {
        street = 'flop'
        debugger
      }

      // always reset to the first street that has diffs
      this.emitUpdate(sizes_final, street)
      this.$emit('update:useFlopSizesOnAllStreets', !this.useFlopSizesOnAllStreets)
    },
    toggleMimicFirstPlayer({ force = false, player } = {}) {
      const isPlayerCloning = this.playersCloningFirstPlayer[player]
      this.showCloningFirstOverrideWarn[player] = false

      const l_sizes = JSON.parse(JSON.stringify(this.sizes))
      let { sizes_final, diffs_total, diffs_from_flop, diffs_from_turn, diffs_from_river } =
        getSizesDiffsOnAllStreets({ sizes: l_sizes, player_from: 'player_oop', player_to: player })

      if (!isPlayerCloning && !force) {
        if (diffs_total) {
          this.showCloningFirstOverrideWarn[player] = true
          return
        }
      }

      // no diffs, just toggle
      if (!diffs_total) {
        this.$emit('update:cloneToFirstPlayer', {
          ...this.playersCloningFirstPlayer,
          [player]: !isPlayerCloning,
        })
        return
      }

      if (this.useFlopSizesOnAllStreets) {
        const res = this.getFlopOnTurnAndRiverDiffs(sizes_final)
        sizes_final = res.sizes_final
      }

      const diffsFlop = diffs_from_flop.total
      const diffsTurn = diffs_from_turn.total
      const diffsRiver = diffs_from_river.total

      const street = diffsFlop //
        ? 'flop'
        : diffsTurn
          ? 'turn'
          : diffsRiver
            ? 'river'
            : 'error'

      if (street === 'error') {
        debugger
      }

      this.emitUpdate(sizes_final, street)
      this.$emit('update:cloneToFirstPlayer', {
        ...this.playersCloningFirstPlayer,
        [player]: !isPlayerCloning,
      })
    },
    getFlopOnTurnAndRiverDiffs(sizes) {
      const res = getFlopOnTurnAndRiverDiffs({
        sizes,
        multiway: this.$store.getters.user_has_flag('SOL_3WAY'),
      })
      return res
    },
    getPlayerCloningState(player) {
      return player !== 'player_oop' && !this.tabPreflop && this.playersCloningFirstPlayer[player]
    },
    getDisplayPosition(position) {
      position = position
        .split('_')
        .pop()
        .toUpperCase()
        .replace(/^(\D+)(\d+)$/, '$1+$2')
      const displayPosition = this.players.find(p => p.position === position)?.display_position
      return this.getPlayerHtmlPosition(displayPosition)
    },
  },
  computed: {
    streetTabsPlayers() {
      return this.players.map(p => `player_${p.position.replace('+', '')?.toLowerCase()}`)
    },
    tabPreflop() {
      return this.streetTab === 'preflop'
    },
    allow_limp() {
      return this.formResult.bet_sizes.street_bet_sizes[0].position_bet_sizes[0].allow_limp
    },
    streetOptions() {
      return [
        // all_streets
        { id: 'preflop', name: this.$t('solfigr.sizes.preflop'), hidden: !this.isPreflop },
        { id: 'flop', name: this.$t('solfigr.sizes.flop') },
        { id: 'turn', name: this.$t('solfigr.sizes.turn') },
        { id: 'river', name: this.$t('solfigr.sizes.river') },
      ].filter(item => !item.hidden)
    },
  },
  watch: {
    isPreflop: { immediate: true, handler: 'handleIsPreflopChanged' },
  },
}
</script>
<style lang="scss" scoped>
.solfigrtp {
  display: flex;
  flex-direction: column;
  &_top {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    min-height: 0;
    min-width: 0;
    gap: 0.5rem;
    gap: var(--solfigr-gap);
    &_btns {
      margin: auto 0;
      flex: 0;
    }
  }
  &_content {
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  &_hspots {
    min-height: 0;
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    &_title {
      border-radius: 4px 4px 0 0;
      display: flex;
      align-items: center;
      background: var(--clr-black-2);
      height: 2.5rem;
      padding: 0 0.75rem;
      &_text {
        font-weight: 500;
      }
    }
    &_content {
      background: var(--clr-black-1);
      padding: 0.5rem 0.75rem;
    }
  }
  &_playerbox {
    min-height: 0;
    min-width: 18rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    overflow: hidden;

    &_title {
      display: flex;
      align-items: center;
      background: var(--clr-black-2);
      height: 2.5rem;
      padding: 0 var(--solfigr-padding);
    }
    &_position {
      font-weight: 500;
      color: var(--clr-white-0);
    }
    &_sizes {
      padding: var(--solfigr-padding);
    }
    &_disabled {
      .solfigrtp_playerbox_position,
      .solfigrtp_playerbox_icon {
        color: var(--clr-grey-2);
      }
    }
  }
  &_advanced {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    &_item {
      background: var(--clr-black-1-3);
      border-radius: 4px;
      padding: 0.5rem;
      font-weight: 600;
      display: flex;
      gap: 0.5rem;
      &_input {
        background: var(--clr-black-1);
        border-radius: 4px;
        padding: 0.25rem;
      }
    }
  }
}
</style>
